/*********************** User MockUp Data Starts ************************/

export const userColumnData = [
  { name: 'index', title: 'Sr#' },
  { name: 'name', title: 'Full Name', isEditable: true },
  { name: 'role', title: 'Role' },
  { name: 'phoneNumber', title: 'Contact Number', isEditable: true },
  { name: 'email', title: 'Contact Email' },
  { name: 'status', title: 'Status' },
  { name: 'isEmailVerified', title: 'Verified Email' },
  { name: 'createdAt', title: 'Created At' },
  { name: 'deletedAt', title: 'Deleted At' },
  { name: 'updatedAt', title: 'Deactivated At' },
  { name: 'action', title: 'Action' }
];

export const userTableColumnExtensions = [
  { columnName: 'index', width: 100 },
  { columnName: 'name', width: 200 },
  { columnName: 'role', width: 100 },
  { columnName: 'phoneNumber', width: 150 },
  { columnName: 'email', width: 150 },
  { columnName: 'status', width: 150 },
  { columnName: 'isEmailVerified', width: 150 },
  { columnName: 'createdAt', width: 150 },
  { columnName: 'deletedAt', width: 150 },
  { columnName: 'updatedAt', width: 150 },
  { columnName: 'action', width: 80 }
];

export const userRowData = [
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactEmail: 'lorem@gmail.com',
    contactNumber: '252565',
    status: true,
    uuid: 'adb86270fdba4bba8900e7371b089ade',
    id: 1
  },
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactNumber: '252565',
    contactEmail: 'lorem@gmail.com',
    status: false,
    uuid: 'adb86270fdba4dda8900e7371b089ade',
    id: 2
  }
];

export const userServicesColumnData = [
  { name: 'index', title: 'Sr#' },
  { name: 'serviceName', title: 'Service Name', isEditable: true },
  { name: 'description', title: 'Description', isEditable: true },
  { name: 'price', title: 'Price', isEditable: true },
  { name: 'duration', title: 'Duration', isEditable: true },
  { name: 'status', title: 'Status' },
  { name: 'actions', title: 'Action' }
];

export const userServicesTableColumnExtensions = [
  { columnName: 'index', width: 100 },
  { columnName: 'serviceName', width: 150 },
  { columnName: 'description', width: 200 },
  { columnName: 'price', width: 100 },
  { columnName: 'duration', width: 100 },
  { columnName: 'status', width: 100 },
  { columnName: 'actions', width: 100 }
];

export const userServicesData = [
  {
    index: 1,
    serviceName: 'Hair Cut',
    description: 'Basic hair cutting service',
    price: 20,
    duration: 30,
    status: 'Active'
  },
  {
    index: 2,
    serviceName: 'Manicure',
    description: 'Nail care and styling',
    price: 25,
    duration: 45,
    status: 'Inactive'
  },
  {
    index: 3,
    serviceName: 'Pedicure',
    description: 'Foot care and styling',
    price: 30,
    duration: 50,
    status: 'Active'
  },
  {
    index: 4,
    serviceName: 'Facial',
    description: 'Skin care treatment',
    price: 40,
    duration: 60,
    status: 'Active'
  }
];

/*********************** User MockUp Data Ends ************************/

/*********************** Services MockUp Data Starts ************************/

export const allServicesColumnData = [
  { name: 'index', title: 'Sr#' },
  { name: 'serviceName', title: 'Service Name' },
  { name: 'description', title: 'Description' },
  // { name: 'salonName', title: 'Salon Name' },
  { name: 'price', title: 'Price' },
  { name: 'duration', title: 'Duration' },
  { name: 'createdAt', title: 'Created At' },
  { name: 'status', title: 'Status' },
  { name: 'action', title: 'Action' }
];

export const allServicesTableColumnExtensions = [
  { columnName: 'index', width: 100 },
  { columnName: 'serviceName', width: 150 },
  { columnName: 'description', width: 200 },
  // { columnName: 'salonName', width: 150 },
  { columnName: 'price', width: 100 },
  { columnName: 'duration', width: 100 },
  { columnName: 'createdAt', width: 150 },
  { columnName: 'status', width: 100 },
  { columnName: 'action', width: 100 }
];

export const allServicesData = [
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactEmail: 'lorem@gmail.com',
    contactNumber: '252565',
    status: true,
    uuid: 'adb86270fdba4bba8900e7371b089ade',
    id: 1
  },
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactNumber: '252565',
    contactEmail: 'lorem@gmail.com',
    status: false,
    uuid: 'adb86270fdba4dda8900e7371b089ade',
    id: 2
  }
];

/*********************** Services MockUp Data Ends ************************/

/*********************** Salons MockUp Data Starts ************************/

export const allSalonsColumnData = [
  { name: 'index', title: 'Sr#' },
  { name: 'salonName', title: 'Salon Name' },
  // { name: 'ownerName', title: 'Owner Name' },
  { name: 'address', title: 'Address' },
  { name: 'city', title: 'City' },
  { name: 'state', title: 'State' },
  { name: 'phoneNumber', title: 'Contact Number' },
  { name: 'zipCode', title: 'Zip Code' },
  { name: 'createdAt', title: 'Created At' }
];

export const allSalonsTableColumnExtensions = [
  { columnName: 'index', width: 100 },
  { columnName: 'salonName', width: 150 },
  // { columnName: 'ownerName', width: 200 },
  { columnName: 'address', width: 200 },
  { columnName: 'city', width: 100 },
  { columnName: 'state', width: 100 },
  { columnName: 'phoneNumber', width: 150 },
  { columnName: 'zipCode', width: 100 },
  { columnName: 'createdAt', width: 150 }
];

export const allSalonsData = [
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactEmail: 'lorem@gmail.com',
    contactNumber: '252565',
    status: true,
    uuid: 'adb86270fdba4bba8900e7371b089ade',
    id: 1
  },
  {
    userName: 'Harry',
    userCode: 'Harry',
    address: 'WDC',
    contactNumber: '252565',
    contactEmail: 'lorem@gmail.com',
    status: false,
    uuid: 'adb86270fdba4dda8900e7371b089ade',
    id: 2
  }
];

/*********************** Salons MockUp Data Ends ************************/

/*********************** ALL Bookings MockUp Data Starts ************************/

export const allBookingsColumnData = [
  { name: 'index', title: 'Sr#' },
  { name: 'bookingUID', title: 'Booking ID' },
  { name: 'serviceName', title: 'Service Name' },
  { name: 'customerName', title: 'Customer Name' },
  { name: 'proName', title: 'Pro Name' },
  { name: 'address', title: 'Address' },
  { name: 'bookingDate', title: 'Booking Date' },
  { name: 'bookingDuration', title: 'Booking Duration' },
  { name: 'status', title: 'Status' },
  { name: 'action', title: 'Action' }
];

export const allBookingsTableColumnExtensions = [
  { columnName: 'index', width: 100 },
  { columnName: 'bookingUID', width: 150 },
  { columnName: 'serviceName', width: 180 },
  { columnName: 'customerName', width: 150 },
  { columnName: 'proName', width: 150 },
  { columnName: 'address', width: 200 },
  { columnName: 'bookingDate', width: 150 },
  { columnName: 'bookingDuration', width: 150 },
  { columnName: 'status', width: 150 }
];

/*********************** ALL Bookings  MockUp Data Ends ************************/

/*********************** User Bookings  MockUp Data Start ************************/
export const userBookingsColumnData = [
  { name: 'idx', title: 'Sr#' },
  { name: 'bookingUID', title: 'Booking ID' },
  { name: 'address', title: 'Address' },
  { name: 'bookingDate', title: 'Booking Date' },
  { name: 'duration', title: 'Booking Duration' },
  { name: 'rating', title: 'Rating' },
  { name: 'ratingDescrition', title: 'Rating Description' },
  { name: 'status', title: 'Status' },
  { name: 'action', title: 'Action' }
];

export const userBookingsTableColumnExtensions = [
  { columnName: 'idx', width: 100 },
  { columnName: 'bookingUID', width: 150 },
  { columnName: 'address', width: 250 },
  { columnName: 'bookingDate', width: 150 },
  { columnName: 'duration', width: 150 },
  { columnName: 'ratingDescrition', width: 150 },
  { columnName: 'rating', width: 150 },
  { columnName: 'status', width: 150 }
];

/*********************** User Bookings  MockUp Data Ends ************************/

/*********************** Salons MockUp Data Ends ************************/
export const statesData = [
  {
    name: 'Alabama',
    abbreviation: 'AL'
  },
  {
    name: 'Alaska',
    abbreviation: 'AK'
  },
  {
    name: 'American Samoa',
    abbreviation: 'AS'
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ'
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR'
  },
  {
    name: 'California',
    abbreviation: 'CA'
  },
  {
    name: 'Colorado',
    abbreviation: 'CO'
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT'
  },
  {
    name: 'Delaware',
    abbreviation: 'DE'
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC'
  },
  {
    name: 'Federated States Of Micronesia',
    abbreviation: 'FM'
  },
  {
    name: 'Florida',
    abbreviation: 'FL'
  },
  {
    name: 'Georgia',
    abbreviation: 'GA'
  },
  {
    name: 'Guam',
    abbreviation: 'GU'
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI'
  },
  {
    name: 'Idaho',
    abbreviation: 'ID'
  },
  {
    name: 'Illinois',
    abbreviation: 'IL'
  },
  {
    name: 'Indiana',
    abbreviation: 'IN'
  },
  {
    name: 'Iowa',
    abbreviation: 'IA'
  },
  {
    name: 'Kansas',
    abbreviation: 'KS'
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY'
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA'
  },
  {
    name: 'Maine',
    abbreviation: 'ME'
  },
  {
    name: 'Marshall Islands',
    abbreviation: 'MH'
  },
  {
    name: 'Maryland',
    abbreviation: 'MD'
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA'
  },
  {
    name: 'Michigan',
    abbreviation: 'MI'
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN'
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS'
  },
  {
    name: 'Missouri',
    abbreviation: 'MO'
  },
  {
    name: 'Montana',
    abbreviation: 'MT'
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE'
  },
  {
    name: 'Nevada',
    abbreviation: 'NV'
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH'
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ'
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM'
  },
  {
    name: 'New York',
    abbreviation: 'NY'
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC'
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND'
  },
  {
    name: 'Northern Mariana Islands',
    abbreviation: 'MP'
  },
  {
    name: 'Ohio',
    abbreviation: 'OH'
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK'
  },
  {
    name: 'Oregon',
    abbreviation: 'OR'
  },
  {
    name: 'Palau',
    abbreviation: 'PW'
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA'
  },
  {
    name: 'Puerto Rico',
    abbreviation: 'PR'
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI'
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC'
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD'
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN'
  },
  {
    name: 'Texas',
    abbreviation: 'TX'
  },
  {
    name: 'Utah',
    abbreviation: 'UT'
  },
  {
    name: 'Vermont',
    abbreviation: 'VT'
  },
  {
    name: 'Virgin Islands',
    abbreviation: 'VI'
  },
  {
    name: 'Virginia',
    abbreviation: 'VA'
  },
  {
    name: 'Washington',
    abbreviation: 'WA'
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV'
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI'
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY'
  }
];
